import React from 'react';
import { CreateCourse } from '@/components/home';
import { Link } from 'react-router-dom';
/**
 * CourseCreationPage
 *
 * A dedicated page for instructors to create new courses.
 * This component provides a structured and welcoming layout
 * that centers the course creation form and offers guiding text.
 */
function CourseCreationPage() {
  return (
    <main className="flex flex-col items-center justify-center p-4 sm:p-6 lg:p-8">
      <div className="w-full max-w-4xl mx-auto">
        <header className="text-center mb-8">
          <h1 className="text-4xl font-bold ">Create Your New Course</h1>
          <p className="text-lg mt-2">
            Turn your knowledge into an opportunity. Fill out the details below to get started.
          </p>
        </header>

        <CreateCourse />

        <footer className="text-center mt-8">
          <p className="text-sm">
            Need help? Visit our{' '}
            <Link to="/help" className="hover:underline">
              Help Center
            </Link>
            .
          </p>
        </footer>
      </div>
    </main>
  );
}

export default CourseCreationPage;
